export default __webpack_public_path__ + "static/media/Gellix-Thin.65220114.woff";